import TrustedHtml from './TrustedHtml'

export default TrustedHtml
